import React, { createContext } from 'react';

// Creamos un ID de sesión único y aleatorio cuando la página carga.
const sessionId = Math.random().toString(36).substring(2, 15);

export const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  return (
    <SessionContext.Provider value={{ sessionId }}>
      {children}
    </SessionContext.Provider>
  );
};